
import vSelect from './vselect'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async doQuery () {
if (this.year === '') {
return
}






let param = { p_name: this.p_name, IEFlag: this.IEFlag, year: this.year }
this.$router.push({name: 'MainGoodsSearchResult', params: param})
},
async getYears () {
const queryPromise = await this.$http.get('/API/MainGoods/Years')
return queryPromise.data
},
clear () {
this.p_name = ''
this.IEFlag = '进口'
this.year = ''
}
},
data () {
return {
yearList: ['', '2017', '2016', '2015', '2016'],
year: '2017',
p_name: '',
IEFlag: '进口',
IEFlagList: ['进口', '出口']
}
},
async activated () {
this.yearList = (await this.getYears()).sort().reverse()
if (this.yearList.length > 0) {
this.year = this.yearList[0]
}
}
}



// WEBPACK FOOTER //
// ./src/components/MainGoods.vue